import { useState, useEffect, useContext } from 'react';
import { useForm } from '../../../../../hooks';
import moment from 'moment';

import {
  Typography,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
} from '@mui/material';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../../../components/common/Table';
import { Grid, Button, TextField } from '../../../../../components/common';
import AccordionFormContext from '../../../../../store/accordion-form-context';

const checkIfDateFuture = (date) => {
  const current = new Date();
  const dateMoment = moment(date, 'YYYY/MM/DD');
  const given = dateMoment.toDate();
  return current < given;
};

const checkIfDateFinishValid = (date, length) => {
  const finish = new Date();
  finish.setFullYear(finish.getFullYear() + parseInt(length));
  const dateMoment = moment(date, 'YYYY/MM/DD');
  const given = dateMoment.toDate();
  return finish < given;
};

export default function FinancialBurdens() {
  const accordionCTX = useContext(AccordionFormContext);
  const { handleChange, setFieldValues, values } = useForm({
    financialLiabilityName: '',
    financialLiabilityAmount: '',
    financialLiabilityLength: '',
    financialLiabilityFinishDate: '',
  });
  const [valid, setValid] = useState(false);

  useEffect(() => {
    if (
      checkIfDateFinishValid(
        values.financialLiabilityFinishDate,
        values.financialLiabilityLength
      )
    )
      setValid(true);
    else setValid(false);
  }, [values.financialLiabilityLength, values.financialLiabilityFinishDate]);

  const handleAddNewFinancialLiability = () => {
    accordionCTX.changeFormValue('financialLiabilityRequestList', [
      ...accordionCTX.form.financialLiabilityRequestList,
      {
        name: values.financialLiabilityName,
        amount: parseFloat(values.financialLiabilityAmount),
        liabilityLength: parseInt(values.financialLiabilityLength),
        finishDate: values.financialLiabilityFinishDate,
      },
    ]);
    setFieldValues({
      financialLiabilityName: '',
      financialLiabilityAmount: '',
      financialLiabilityLength: '',
      financialLiabilityFinishDate: '',
    });
  };

  return (
    <Accordion
      square
      expanded={accordionCTX.navigation.expanded === 'panel6'}
      onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel6')}
    >
      <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
        <h1>6. Obciążenia finansowe</h1>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid
            infoCard
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            component={Paper}
          >
            <Typography variant="h4">
              Poniżej możesz dodać obciążenia finansowe, jak kredyty, raty itp.
            </Typography>
          </Grid>
          <Grid
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="left">
                      Nazwa obciążenia finansowego
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Pełna kwota obciążenia
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Długość obciążenia (w latach)
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Data zakończenia
                    </StyledTableCell>
                    <StyledTableCell align="right" />
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {accordionCTX.form.financialLiabilityRequestList.map(
                    (row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                          {row.name}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.amount} zł
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.liabilityLength}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.finishDate}
                        </StyledTableCell>
                        <StyledTableCell
                          component="th"
                          scope="row"
                          align={'right'}
                        >
                          <Button
                            onClick={() => {
                              let array = [
                                ...accordionCTX.form
                                  .financialLiabilityRequestList,
                              ];
                              array.splice(index, 1);
                              accordionCTX.changeFormValue(
                                'financialLiabilityRequestList',
                                array
                              );
                            }}
                            variant="contained"
                          >
                            Usuń obciążenie
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid
            topMargin
            container
            justifyContent="center"
            alignItems="top"
            direction={'row'}
            spacing={2}
          >
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                autoFocus
                fullWidth
                value={values.financialLiabilityName}
                id="financialLiabilityName"
                label="Podaj nazwę obciążenia"
                name="financialLiabilityName"
                onChange={handleChange('financialLiabilityName')}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                type="number"
                margin="normal"
                value={values.financialLiabilityAmount}
                required
                fullWidth
                id="financialLiabilityAmount"
                label="Podaj pełną kwotę obciążenia w PLN"
                name="financialLiabilityAmount"
                onChange={handleChange('financialLiabilityAmount')}
                error={parseFloat(values.financialLiabilityAmount) <= 0}
                helperText={
                  parseInt(values.financialLiabilityAmount) <= 0 &&
                  'Tylko wartości większe od 0'
                }
              />
            </Grid>
          </Grid>
          <Grid
            topMargin
            container
            justifyContent="center"
            alignItems="top"
            direction={'row'}
            spacing={2}
          >
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                margin="normal"
                type="number"
                required
                fullWidth
                value={values.financialLiabilityLength}
                id="financialLiabilityLength"
                label="Podaj okres trwania obciążenia w latach"
                name="financialLiabilityLength"
                onChange={handleChange('financialLiabilityLength')}
                error={parseInt(values.financialLiabilityLength) <= 0}
                helperText={
                  parseInt(values.financialLiabilityLength) <= 0 &&
                  'Tylko wartości większe od 0'
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                margin="normal"
                value={values.financialLiabilityFinishDate}
                required
                fullWidth
                type="date"
                id="financialLiabilityFinishDate"
                label="Podaj datę zakończenia"
                name="financialLiabilityFinishDate"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={handleChange('financialLiabilityFinishDate')}
                error={!valid && values.financialLiabilityFinishDate.length > 0}
                helperText={
                  !valid &&
                  values.financialLiabilityFinishDate.length > 0 &&
                  'Okres obciążenia i podana data nie zgadzają się'
                }
              />
            </Grid>
          </Grid>
          <Grid topMargin container justifyContent="center">
            <Button
              variant="contained"
              onClick={handleAddNewFinancialLiability}
              disabled={
                values.financialLiabilityFinishDate.length === 0 ||
                values.financialLiabilityName.length === 0 ||
                values.financialLiabilityLength.length === 0 ||
                values.financialLiabilityAmount.length === 0 ||
                parseFloat(values.financialLiabilityAmount) <= 0 ||
                parseInt(values.financialLiabilityLength) <= 0 ||
                !valid
              }
            >
              Dodaj
            </Button>
          </Grid>
          <Grid topMargin container justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              onClick={() => accordionCTX.changeNavigation('UNLOCK', 'panel7')}
            >
              Akceptuję obciążenia, chcę przejść dalej
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
